import React from 'react';
import TableRow from './TableRow';

const MainTable = ({ habits, handleDelete, handleDayClick, handleHabitRefresh}) => {

    return (
    <>
        {habits.length ?    
         <table>
            <thead>
                <tr>
                    <th>Calendar</th>
                </tr>
            </thead>
            
            <tbody>
            {habits.map((habit) => (
                <TableRow 
                    key={habit.id} 
                    habit={habit} 
                    handleDelete={handleDelete} 
                    handleDayClick={handleDayClick} 
                    handleHabitRefresh={handleHabitRefresh} 
                />
            ))}
            </tbody>
        </table> : ''}
    </>
    )
};

export default MainTable